import { createFileRoute } from '@tanstack/react-router';
import { useMemo, useState } from 'react';
import ActionButton from '@/components/Button/ActionButton';
import { Card } from '@/components/Card/card';
import ComingSoonCover from '@/components/ComingSoonCover';
import { DataTable, DataTablePagination } from '@/components/DataTable';
import { FillScreen, HStack, VStack } from '@/components/Layout';
import SearchInput from '@/components/SearchInput';
import { Text } from '@/components/Typography/Text';
import { MOCK_ONLY_FEATURE_FLAG } from '@/constants/featureFlags';
import { featureFlags } from '@/lib/env';
import placeholder from '../_placeholders/-assets/placeholder-rule-and-policy.png';
import { RuleAndPolicyResourceSidebar } from './-components/RuleAndPolicyResourceSidebar';
import { useRuleTable } from './-hooks/useTable';
import { useLicenseAssignmentRules } from './-query';
export const Route = createFileRoute('/_staff/licenses/_list/rule-and-policy/')({
  component: LicenseRuleAndPolicy
});
function LicenseRuleAndPolicy() {
  const isMockEnabled = featureFlags.check(MOCK_ONLY_FEATURE_FLAG);
  const {
    data,
    isPending
  } = useLicenseAssignmentRules({
    enabled: isMockEnabled
  });
  const [keyword, setKeyword] = useState('');
  const rows = useMemo(() => {
    const items = data ?? [];
    const lower = keyword.trim().toLowerCase();
    if (!lower) return items;
    return items.filter(item => [item.softwareName, item.licenseName, item.memberGroup, item.deviceGroup].some(field => field.toLowerCase().includes(lower)));
  }, [data, keyword]);
  const {
    table,
    displayState
  } = useRuleTable(rows, isPending);

  // MOCK_ONLY 無効時は従来どおり ComingSoon（非破壊）
  if (!isMockEnabled) {
    return <ComingSoonCover placeholderImage={placeholder} />;
  }
  return <FillScreen className="flex">
      <RuleAndPolicyResourceSidebar />
      <VStack className="min-h-0 min-w-0 flex-1 gap-4 px-8 py-5">
        <Text variant="h4">アサインメントルール: ライセンス割り当て</Text>

        <Card className="p-2 shadow-xs">
          <HStack className="items-center gap-2">
            <SearchInput value={keyword} onChange={e => setKeyword(e.target.value)} placeholder="ライセンス・グループで検索" className="w-[280px]" />
            <ActionButton icon="Download" variant="ghost" iconColor="primary" className="ml-auto shrink-0" disabled>
              エクスポート
            </ActionButton>
          </HStack>
        </Card>

        <Card className="min-h-0 flex-1 overflow-auto shadow-xs">
          <DataTable table={table} displayState={displayState} isHoverable={false} onRowClick={null} />
        </Card>

        <DataTablePagination table={table} totalCount={rows.length} pageOptions={[20, 50, 100]} />
      </VStack>
    </FillScreen>;
}